class TestimonialSlider {
    constructor(container) {
      this.container = container;
      this.splideInstance = null;
      this.progressBar = null;
      this.progressBarContainer = null;
      this.init();
    }
  
    init() {
      this.handleSplideSlider();
    }
  
    handleSplideSlider() {
      const slider = this.container;
      if (slider) {
        this.splideInstance = new Splide(slider, {
          type: 'slide',
          perPage: 1,
          perMove: 1,
          autoplay: false,
          arrows: false,
          pagination: false
        });
  
        this.splideInstance.on('mounted', () => {
          this.progressBar = document.querySelector('.testimonial-slider-scroll-bar');
          this.progressBarContainer = document.querySelector('.testimonial-slider-scroll');
  
          const updateProgress = () => {
            const totalItems = this.splideInstance.Components.Elements.slides.length;
            const currentSlideIndex = this.splideInstance.index;
            this.progressBar.style.width = `${100 / totalItems}%`;
            this.progressBar.style.marginLeft = `${currentSlideIndex * (100 / totalItems)}%`;
            this.progressBar.style.transition = 'margin 500ms';
          };
  
          updateProgress();
  
          this.splideInstance.on('move', updateProgress);
  
          this.progressBarContainer.addEventListener('click', (event) => {
            this.handleScrollbarClick(event);
          });
        });
  
        this.splideInstance.mount();
      }
    }
  
    handleScrollbarClick(event) {
      if (!this.splideInstance) return;
      const totalItems = this.splideInstance.Components.Elements.slides.length;
      const containerRect = this.progressBarContainer.getBoundingClientRect();
      const clientX = event.clientX || (event.changedTouches && event.changedTouches[0].clientX);
      const clickX = clientX - containerRect.left;
      const zoneWidth = containerRect.width / totalItems;
      const targetItem = Math.floor(clickX / zoneWidth);
      this.splideInstance.go(targetItem);
    }
  }
  
  document.addEventListener("DOMContentLoaded", function () {
    const testimonialSection = document.querySelector('#testimonial-slider');
    const mediaSection = document.querySelector('#media-slider');
  
    if (testimonialSection && mediaSection) {
      const testimonialSlider = new TestimonialSlider(testimonialSection);
  
      const mediaSlider = new Splide(mediaSection, {
        type: 'fade',
        perPage: 1,
        perMove: 1,
        autoplay: false,
        arrows: false,
        pagination: false,
      }).mount();
  
      testimonialSlider.splideInstance.sync(mediaSlider);
    } else if (testimonialSection) {
      new TestimonialSlider(testimonialSection);
    }
  });
  